import { useState, useContext } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import Swal from "sweetalert2";
import { AuthContext } from "../../../Provider/AuthProvider";

const ResetPassword = () => {
  const [email, setEmail] = useState("");
  const { auth } = useContext(AuthContext); 

  const handleReset = async (e) => {
    e.preventDefault();
    try {
      await sendPasswordResetEmail(auth, email);
      Swal.fire({
        title: "Password Reset Email Sent",
        text: `Check your inbox at ${email}`,
        icon: "success",
      });
      setEmail("");
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: error.message,
        icon: "error",
      });
    }
  };

  return (
    <div className="bg-[#F4FBFF] min-h-screen flex items-center justify-center">
      <div className="card w-full max-w-md bg-white shadow-lg p-8">
        <h1 className="text-3xl font-bold mb-6 text-center">Reset Password</h1>
        <form onSubmit={handleReset} className="space-y-4">
          <div>
            <label className="label font-semibold">Email Address</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="Enter your email"
              className="input input-bordered w-full"
            />
          </div>
          <button className="btn w-full bg-[#55D4AB] border-0 text-white text-lg hover:bg-[#f0ca4e] hover:text-black">
            Send Reset Link
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
